import { Directive, OnDestroy } from '@angular/core';

import { map, switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { select, Store } from '@ngrx/store';

import * as fromRootStore from '@apps/root/store';
import { IAuroraState } from '@apps/aurora.state';

@Directive()
export class ListItemComponent implements OnDestroy
{
    public qsWord: string;
    protected destroyator = new Subject();

    constructor (
        routerStore: Store<any>,
        store: Store<IAuroraState>
    )
    {
        routerStore
            .pipe(
                take(1),
                select(fromRootStore.getRouteInfos),
                map((obj: any): string =>
                    obj.url
                ),
                switchMap((url: string) =>
                {
                    url = url === '/admin/impersonate' ? '/admin/impersonate/popin/entity' : url;

                    return store.pipe(
                        select(fromRootStore.getQuickSearchValue, { key: url }),
                        tap((qsWord: string) =>
                        {
                            this.qsWord = qsWord;
                        }),
                        takeUntil(this.destroyator)
                    );
                })
            ).subscribe();
    }

    ngOnDestroy ()
    {
        this.destroyator.next(null);
        this.destroyator.complete();
    }
}
